do
  let isPrime = (n) -> if n < 2 then
    false
  else if n == 2 then
    true
  else if n % 2 == 0 then
    false
  else
    loop(i = 3) -> if i * i > n then
      true
    else if n % i == 0 then
      false
    else
      recur(i + 2)
    end
  end;

  let isPerfectSquare = (n) -> if n < 0 then
    false
  else
    do
      let s = floor(sqrt(n));
      s * s == n;
    end
  end;
  let isPerfectCube = (n) -> do
    let c = round(sign(n) * abs(n) ^ (1 / 3));
    c * c * c == n;
  end;
  let sumProperDivisors = (n) -> if n <= 1 then
    0
  else
    loop(i = 2, acc = 1) -> if i * i > n then
      acc
    else if n % i == 0 then
      if i * i == n then
        recur(i + 1, acc + i)
      else
        recur(i + 1, acc + i + n / i)
      end
    else
      recur(i + 1, acc)
    end
  end;
  let isAbundant = (n) -> n > 0 && sumProperDivisors(n) > n;
  let isDeficient = (n) -> n > 0 && sumProperDivisors(n) < n;
  let isComposite = (n) -> n > 1 && not(isPrime(n));
  let isHappy = (n) -> do
    let sumOfSquaredDigits = (x) -> loop(num = x, acc = 0) -> if num == 0 then
      acc
    else
      do
        let d = num % 10;
        recur(floor(num / 10), acc + d * d);
      end
    end;
    loop(slow = n, fast = sumOfSquaredDigits(n)) -> if fast == 1 then
      true
    else if slow == fast then
      false
    else
      recur(
        sumOfSquaredDigits(slow),
        sumOfSquaredDigits(sumOfSquaredDigits(fast))
      )
    end;
  end;
  let countBits = (n) -> loop(x = n, acc = 0) -> if x == 0 then
    acc
  else
    recur(floor(x / 2), acc + x % 2)
  end;
  let isPerfectPower = (n) -> if n == 1 then
    true
  else if n < 2 then
    false
  else
    loop(k = 2) -> if 2 ^ k > n then
      false
    else
      do
        let b = round(n ^ (1 / k));
        if b ^ k == n then true else recur(k + 1) end;
      end
    end
  end;
  let binom = (n, k) -> if k == 0 || k == n then
    1
  else
    loop(i = 0, k2 = min(k, n - k), acc = 1) -> if i >= k2 then
      acc
    else
      recur(i + 1, k2, acc * (n - i) / (i + 1))
    end
  end;
  let bellNumbers = [
    1,
    2,
    5,
    15,
    52,
    203,
    877,
    4140,
    21147,
    115975,
    678570,
    4213597,
    27644437,
    190899322,
    1382958545,
    10480142147,
    82864869804,
    682076806159,
    5832742205057,
    51724158235372,
    474869816156751,
    4506715738447323,
  ];
  let catalanNumbers = [
    1,
    2,
    5,
    14,
    42,
    132,
    429,
    1430,
    4862,
    16796,
    58786,
    208012,
    742900,
    2674440,
    9694845,
    35357670,
    129644790,
    477638700,
    1767263190,
    6564120420,
    24466267020,
    91482563640,
    343059613650,
    1289904147324,
    4861946401452,
    18367353072152,
    69533550916004,
    263747951750360,
    1002242216651368,
    3814986502092304,
  ];
  let mersenneNumbers = [3, 7, 31, 127, 2047, 8191, 131071, 524287, 2147483647];
  let perfectNumbers = [6, 28, 496, 8128, 33550336, 8589869056, 137438691328];
  let sylvesterNumbers = [2, 6, 42, 1806, 3263442, 10650056950806];
  let luckyNumbers = [
    1,
    3,
    7,
    9,
    13,
    15,
    21,
    25,
    31,
    33,
    37,
    43,
    49,
    51,
    63,
    67,
    69,
    73,
    75,
    79,
    87,
    93,
    99,
    105,
    111,
    115,
    127,
    129,
    133,
    135,
    141,
    151,
    159,
    163,
    169,
    171,
    189,
    193,
    195,
    201,
    205,
    211,
    219,
    223,
    231,
    235,
    237,
    241,
    259,
    261,
    267,
    273,
    283,
    285,
    289,
    297,
    303,
    307,
    319,
    321,
    327,
    331,
    339,
    349,
    357,
    361,
    367,
    385,
    391,
    393,
    399,
    409,
    415,
    421,
    427,
    429,
    433,
    451,
    463,
    475,
    477,
    483,
    487,
    489,
    495,
    511,
    517,
    519,
    529,
    535,
    537,
    541,
    553,
    559,
    577,
    579,
    583,
    591,
    601,
    613,
    615,
    619,
    621,
    631,
    639,
    643,
    645,
    651,
    655,
    673,
    679,
    685,
    693,
    699,
    717,
    723,
    727,
    729,
    735,
    739,
    741,
    745,
    769,
    777,
    781,
    787,
    801,
    805,
    819,
    823,
    831,
    841,
    855,
    867,
    873,
    883,
    885,
    895,
    897,
    903,
    925,
    927,
    931,
    933,
    937,
    957,
    961,
    975,
    979,
    981,
    991,
    993,
    997,
    1009,
    1011,
    1021,
    1023,
    1029,
    1039,
    1041,
    1053,
    1057,
    1087,
    1093,
    1095,
    1101,
    1105,
    1107,
    1117,
    1123,
    1147,
    1155,
    1167,
    1179,
    1183,
    1189,
    1197,
    1201,
    1203,
    1209,
    1219,
    1231,
    1233,
    1245,
    1249,
    1251,
    1261,
    1263,
    1275,
    1281,
    1285,
    1291,
    1303,
    1309,
    1323,
    1329,
    1339,
    1357,
    1365,
    1369,
    1387,
    1389,
    1395,
    1401,
    1417,
    1419,
    1435,
    1441,
    1455,
    1459,
    1471,
    1473,
    1485,
    1491,
    1495,
    1497,
    1501,
    1503,
    1519,
    1533,
    1543,
    1545,
    1563,
    1567,
    1575,
    1579,
    1585,
    1587,
    1597,
    1599,
    1611,
    1639,
    1641,
    1645,
    1659,
    1663,
    1675,
    1693,
    1701,
    1705,
    1711,
    1723,
    1731,
    1737,
    1749,
    1765,
    1767,
    1771,
    1773,
    1777,
    1797,
    1801,
    1809,
    1819,
    1827,
    1831,
    1833,
    1839,
    1857,
    1869,
    1879,
    1893,
    1899,
    1915,
    1921,
    1923,
    1933,
    1941,
    1945,
    1959,
    1963,
    1965,
    1977,
    1983,
    1987,
    1995,
    2001,
    2019,
    2023,
    2031,
    2053,
    2059,
    2065,
    2067,
    2079,
    2083,
    2085,
    2095,
    2113,
    2115,
    2121,
    2125,
    2127,
    2133,
    2163,
    2173,
    2187,
    2209,
    2211,
    2215,
    2217,
    2221,
    2239,
    2251,
    2253,
    2257,
    2271,
    2277,
    2281,
    2283,
    2301,
    2311,
    2317,
    2323,
    2335,
    2343,
    2355,
    2365,
    2379,
    2395,
    2403,
    2407,
    2409,
    2415,
    2419,
    2427,
    2439,
    2445,
    2461,
    2467,
    2473,
    2479,
    2491,
    2493,
    2505,
    2511,
    2523,
    2527,
    2545,
    2557,
    2563,
    2571,
    2575,
    2587,
    2589,
    2593,
    2599,
    2607,
    2625,
    2635,
    2647,
    2649,
    2653,
    2661,
    2667,
    2671,
    2689,
    2697,
    2715,
    2725,
    2755,
    2763,
    2773,
    2781,
    2785,
    2787,
    2797,
    2815,
    2817,
    2821,
    2823,
    2827,
    2835,
    2841,
    2845,
    2851,
    2877,
    2887,
    2899,
    2901,
    2905,
    2913,
    2923,
    2943,
    2953,
    2961,
    2971,
    2973,
    2977,
    2983,
    3003,
    3007,
    3027,
    3031,
    3037,
    3039,
    3049,
    3055,
    3073,
    3075,
    3091,
    3097,
    3099,
    3109,
    3111,
    3121,
    3123,
    3133,
    3153,
    3163,
    3171,
    3175,
    3183,
    3187,
    3199,
    3213,
    3223,
    3229,
    3235,
    3243,
    3259,
    3261,
    3289,
    3297,
    3301,
    3307,
    3313,
    3325,
    3339,
    3351,
    3355,
    3363,
    3381,
    3403,
    3405,
    3409,
    3411,
    3427,
    3433,
    3439,
    3451,
    3453,
    3465,
    3477,
    3481,
    3487,
    3489,
    3495,
    3499,
    3507,
    3559,
    3565,
    3571,
    3579,
    3595,
    3597,
    3603,
    3607,
    3613,
    3621,
    3625,
    3633,
    3655,
    3661,
    3663,
    3669,
    3675,
    3685,
    3687,
    3697,
    3709,
    3717,
    3721,
    3727,
    3747,
    3753,
    3763,
    3771,
    3781,
    3789,
    3793,
    3795,
    3811,
    3843,
    3847,
    3849,
    3865,
    3873,
    3879,
    3889,
    3891,
    3897,
    3909,
    3915,
    3931,
    3943,
    3951,
    3955,
    3969,
    3975,
    3981,
    3991,
    3999,
    4003,
    4015,
    4023,
    4033,
    4035,
    4041,
    4045,
    4063,
    4069,
    4081,
    4095,
    4105,
    4107,
    4129,
    4131,
    4161,
    4165,
    4173,
    4179,
    4189,
    4195,
    4201,
    4203,
    4207,
    4227,
    4237,
    4251,
    4255,
    4257,
    4263,
    4269,
    4285,
    4287,
    4315,
    4321,
    4329,
    4335,
    4363,
    4377,
    4383,
    4389,
    4399,
    4413,
    4431,
    4441,
    4443,
    4455,
    4461,
    4465,
    4483,
    4485,
    4495,
    4509,
    4519,
    4521,
    4539,
    4551,
    4561,
    4567,
    4569,
    4573,
    4587,
    4609,
    4611,
    4621,
    4623,
    4629,
    4645,
    4647,
    4653,
    4663,
    4671,
    4675,
    4695,
    4699,
    4713,
    4717,
    4725,
    4741,
    4761,
    4767,
    4773,
    4797,
    4801,
    4809,
    4813,
    4819,
    4833,
    4837,
    4839,
    4843,
    4851,
    4863,
    4867,
    4881,
    4887,
    4893,
    4929,
    4951,
    4963,
    4965,
    4969,
    4977,
    4987,
    4989,
    4993,
    4999,
    5001,
    5007,
    5019,
    5029,
    5041,
    5043,
    5049,
    5053,
    5089,
    5103,
    5127,
    5137,
    5139,
    5149,
    5151,
    5157,
    5169,
    5179,
    5181,
    5191,
    5211,
    5217,
    5229,
    5233,
    5235,
    5253,
    5259,
    5277,
    5283,
    5293,
    5295,
    5299,
    5325,
    5335,
    5341,
    5343,
    5371,
    5377,
    5379,
    5385,
    5409,
    5419,
    5427,
    5433,
    5449,
    5455,
    5463,
    5473,
    5487,
    5491,
    5503,
    5515,
    5527,
    5547,
    5551,
    5559,
    5569,
    5577,
    5587,
    5589,
    5593,
    5599,
    5613,
    5617,
    5637,
    5641,
    5649,
    5655,
    5661,
    5671,
    5673,
    5679,
    5691,
    5701,
    5707,
    5713,
    5719,
    5737,
    5755,
    5763,
    5767,
    5769,
    5803,
    5809,
    5817,
    5827,
    5833,
    5839,
    5851,
    5869,
    5883,
    5889,
    5893,
    5901,
    5905,
    5911,
    5913,
    5923,
    5959,
    5965,
    5967,
    5971,
    5973,
    5977,
    5991,
    5997,
    6009,
    6019,
    6031,
    6049,
    6055,
    6061,
    6079,
    6093,
    6111,
    6115,
    6123,
    6141,
    6147,
    6159,
    6163,
    6175,
    6177,
    6195,
    6211,
    6229,
    6237,
    6243,
    6249,
    6253,
    6271,
    6273,
    6279,
    6301,
    6309,
    6331,
    6345,
    6351,
    6355,
    6363,
    6367,
    6369,
    6373,
    6379,
    6385,
    6399,
    6411,
    6415,
    6427,
    6433,
    6435,
    6447,
    6463,
    6471,
    6475,
    6477,
    6501,
    6505,
    6523,
    6531,
    6535,
    6541,
    6553,
    6559,
    6567,
    6573,
    6601,
    6621,
    6625,
    6631,
    6661,
    6663,
    6667,
    6669,
    6679,
    6687,
    6693,
    6715,
    6723,
    6733,
    6741,
    6745,
    6747,
    6753,
    6757,
    6763,
    6765,
    6783,
    6787,
    6789,
    6841,
    6849,
    6867,
    6871,
    6883,
    6891,
    6909,
    6915,
    6921,
    6931,
    6933,
    6937,
    6951,
    6981,
    6985,
    6999,
    7003,
    7009,
    7035,
    7041,
    7045,
    7047,
    7069,
    7077,
    7081,
    7087,
    7101,
    7111,
    7129,
    7135,
    7153,
    7167,
    7171,
    7173,
    7183,
    7191,
    7195,
    7197,
    7207,
    7215,
    7231,
    7233,
    7237,
    7245,
    7249,
    7279,
    7293,
    7299,
    7311,
    7321,
    7333,
    7339,
    7341,
    7345,
    7357,
    7359,
    7371,
    7377,
    7395,
    7401,
    7405,
    7419,
    7435,
    7437,
    7443,
    7447,
    7459,
    7471,
    7489,
    7501,
    7503,
    7507,
    7531,
    7533,
    7549,
    7551,
    7563,
    7567,
    7575,
    7585,
    7591,
    7593,
    7603,
    7609,
    7629,
    7633,
    7639,
    7645,
    7677,
    7687,
    7689,
    7701,
    7711,
    7717,
    7737,
    7755,
    7779,
    7791,
    7795,
    7801,
    7803,
    7813,
    7827,
    7833,
    7837,
    7855,
    7881,
    7885,
    7897,
    7899,
    7909,
    7917,
    7921,
    7929,
    7939,
    7947,
    7951,
    7963,
    7969,
    7971,
    8001,
    8005,
    8007,
    8013,
    8037,
    8047,
    8071,
    8073,
    8085,
    8089,
    8107,
    8109,
    8127,
    8131,
    8139,
    8151,
    8161,
    8169,
    8173,
    8175,
    8191,
    8193,
    8221,
    8223,
    8227,
    8233,
    8253,
    8257,
    8263,
    8269,
    8283,
    8289,
    8299,
    8325,
    8331,
    8347,
    8359,
    8365,
    8367,
    8379,
    8409,
    8413,
    8421,
    8445,
    8449,
    8467,
    8473,
    8475,
    8479,
    8487,
    8493,
    8515,
    8535,
    8539,
    8551,
    8553,
    8575,
    8577,
    8583,
    8589,
    8601,
    8605,
    8611,
    8617,
    8635,
    8637,
    8641,
    8647,
    8655,
    8661,
    8673,
    8683,
    8719,
    8757,
    8769,
    8773,
    8787,
    8793,
    8805,
    8809,
    8827,
    8829,
    8833,
    8835,
    8841,
    8869,
    8871,
    8895,
    8913,
    8931,
    8937,
    8947,
    8955,
    8961,
    8977,
    8979,
    8989,
    8995,
    8997,
    9009,
    9031,
    9033,
    9061,
    9063,
    9073,
    9075,
    9081,
    9085,
    9115,
    9117,
    9121,
    9123,
    9135,
    9139,
    9145,
    9151,
    9177,
    9181,
    9211,
    9213,
    9223,
    9231,
    9235,
    9249,
    9253,
    9267,
    9273,
    9277,
    9285,
    9291,
    9303,
    9315,
    9331,
    9339,
    9349,
    9373,
    9387,
    9399,
    9403,
    9409,
    9421,
    9423,
    9429,
    9441,
    9451,
    9457,
    9471,
    9475,
    9481,
    9483,
    9487,
    9501,
    9535,
    9537,
    9543,
    9547,
    9549,
    9555,
    9561,
    9567,
    9613,
    9621,
    9625,
    9631,
    9643,
    9649,
    9661,
    9663,
    9675,
    9687,
    9691,
    9703,
    9727,
    9733,
    9751,
    9753,
    9775,
    9787,
    9789,
    9795,
    9801,
    9807,
    9811,
    9813,
    9837,
    9841,
    9883,
    9895,
    9915,
    9927,
    9937,
    9957,
    9961,
    9979,
    9985,
    9987,
    9997,
    9999,
    10003,
    10009,
    10017,
    10041,
    10051,
    10059,
    10069,
    10071,
    10083,
    10087,
    10089,
    10095,
    10111,
    10117,
    10125,
    10131,
    10143,
    10147,
    10149,
    10153,
    10173,
    10191,
    10195,
    10197,
    10221,
    10239,
    10255,
    10261,
    10275,
    10279,
    10291,
    10311,
    10315,
    10317,
    10321,
    10341,
    10363,
    10365,
    10387,
    10399,
    10411,
    10417,
    10431,
    10441,
    10443,
    10459,
    10461,
    10471,
    10501,
    10507,
    10509,
    10525,
    10531,
    10533,
    10555,
    10563,
    10569,
    10575,
    10585,
    10587,
    10597,
    10599,
    10605,
    10609,
    10635,
    10651,
    10653,
    10659,
    10671,
    10683,
    10723,
    10725,
    10731,
    10747,
    10753,
    10755,
    10759,
    10773,
    10785,
    10789,
    10797,
    10809,
    10843,
    10849,
    10873,
    10881,
    10891,
    10903,
    10909,
    10911,
    10921,
    10923,
    10945,
    10953,
    10965,
    10975,
    10977,
    11005,
    11011,
    11017,
    11047,
    11055,
    11059,
    11073,
    11077,
    11089,
    11091,
    11097,
    11113,
    11137,
    11157,
    11163,
    11173,
    11181,
    11193,
    11197,
    11205,
    11217,
    11223,
    11227,
    11239,
    11245,
    11247,
    11259,
    11263,
    11269,
    11283,
    11289,
    11301,
    11323,
    11341,
    11343,
    11371,
    11373,
    11377,
    11389,
    11391,
    11395,
    11407,
    11419,
    11425,
    11427,
    11437,
    11439,
    11475,
    11479,
    11487,
    11491,
    11521,
    11529,
    11535,
    11539,
    11541,
    11577,
    11581,
    11583,
    11599,
    11617,
    11623,
    11629,
    11641,
    11643,
    11659,
    11667,
    11677,
    11679,
    11707,
    11721,
    11725,
    11731,
    11769,
    11781,
    11797,
    11803,
    11811,
    11815,
    11823,
    11827,
    11833,
    11835,
    11845,
    11847,
    11853,
    11865,
    11877,
    11887,
    11911,
    11923,
    11929,
    11943,
    11953,
    11959,
    11961,
    11991,
    11995,
    12007,
    12015,
    12025,
    12049,
    12057,
    12063,
    12069,
    12079,
    12097,
    12103,
    12117,
    12121,
    12133,
    12139,
    12141,
    12151,
    12159,
    12163,
    12165,
    12193,
    12201,
    12207,
    12223,
    12237,
    12243,
    12265,
    12267,
    12285,
    12295,
    12301,
    12307,
    12315,
    12319,
    12321,
    12333,
    12337,
    12357,
    12363,
    12373,
    12379,
    12391,
    12399,
    12411,
    12417,
    12427,
    12435,
    12457,
    12481,
    12487,
    12495,
    12499,
    12519,
    12543,
    12547,
    12553,
    12567,
    12579,
    12589,
    12607,
    12609,
    12621,
    12631,
    12645,
    12649,
    12651,
    12673,
    12679,
    12699,
    12709,
    12711,
    12729,
    12735,
    12741,
    12759,
    12763,
    12777,
    12781,
    12799,
    12801,
    12813,
    12819,
    12861,
    12867,
    12877,
    12885,
    12903,
    12907,
    12925,
    12937,
    12951,
    12957,
    12961,
    12969,
    12991,
    12999,
    13009,
    13011,
    13021,
    13027,
    13029,
    13053,
    13057,
    13063,
    13077,
    13083,
    13113,
    13117,
    13119,
    13125,
    13129,
    13135,
    13141,
    13167,
    13177,
    13179,
    13203,
    13209,
    13215,
    13219,
    13243,
    13245,
    13267,
    13273,
    13279,
    13281,
    13285,
    13293,
    13309,
    13317,
    13323,
    13327,
    13335,
    13345,
    13347,
    13359,
    13363,
    13371,
    13387,
    13419,
    13441,
    13443,
    13465,
    13473,
    13485,
    13489,
    13513,
    13515,
    13519,
    13527,
    13531,
    13533,
    13537,
    13551,
    13567,
    13575,
    13581,
    13587,
    13599,
    13609,
    13633,
    13657,
    13677,
    13681,
    13693,
    13695,
    13707,
    13723,
    13725,
    13737,
    13741,
    13743,
    13759,
    13801,
    13803,
    13821,
    13831,
    13833,
    13849,
    13851,
    13861,
    13873,
    13893,
    13897,
    13929,
    13947,
    13953,
    13957,
    13995,
    14007,
    14017,
    14031,
    14035,
    14037,
    14041,
    14049,
    14053,
    14059,
    14073,
    14079,
    14091,
    14095,
    14113,
    14115,
    14119,
    14137,
    14163,
    14179,
    14181,
    14185,
    14199,
    14205,
    14209,
    14211,
    14217,
    14229,
    14245,
    14247,
    14253,
    14281,
    14287,
    14293,
    14307,
    14313,
    14317,
    14331,
    14347,
    14349,
    14353,
    14367,
    14395,
    14407,
    14419,
    14427,
    14437,
    14439,
    14443,
    14449,
    14457,
    14461,
    14473,
    14491,
    14493,
    14505,
    14521,
    14523,
    14539,
    14541,
    14565,
    14587,
    14595,
    14599,
    14601,
    14607,
    14625,
    14661,
    14667,
    14689,
    14691,
    14713,
    14715,
    14721,
    14731,
    14749,
    14751,
    14755,
    14775,
    14779,
    14785,
    14793,
    14797,
    14817,
    14841,
    14875,
    14881,
    14883,
    14899,
    14905,
    14919,
    14923,
    14931,
    14935,
    14943,
    14947,
    14973,
    14977,
    14997,
    15003,
    15007,
    15009,
    15025,
    15031,
    15049,
    15057,
    15063,
    15069,
    15073,
    15081,
    15103,
    15109,
    15121,
    15129,
    15133,
    15141,
    15165,
    15169,
    15175,
    15183,
    15187,
    15189,
    15193,
    15205,
    15213,
    15217,
    15229,
    15231,
    15235,
    15237,
    15247,
    15255,
    15259,
    15261,
    15271,
    15291,
    15301,
    15313,
    15333,
    15355,
    15379,
    15381,
    15385,
    15397,
    15417,
    15445,
    15457,
    15469,
    15471,
    15481,
    15487,
    15489,
    15511,
    15519,
    15523,
    15531,
    15543,
    15547,
    15567,
    15573,
    15577,
    15585,
    15597,
    15609,
    15645,
    15655,
    15661,
    15673,
    15675,
    15693,
    15697,
    15717,
    15735,
    15763,
    15771,
    15783,
    15793,
    15805,
    15817,
    15819,
    15835,
    15843,
    15847,
    15855,
    15879,
    15883,
    15891,
    15901,
    15907,
    15919,
    15927,
    15939,
    15955,
    15969,
    15975,
    15981,
    15993,
    16003,
    16009,
    16023,
    16045,
    16047,
    16053,
    16057,
    16077,
    16081,
    16095,
    16101,
    16135,
    16153,
    16191,
    16195,
    16197,
    16203,
    16213,
    16227,
    16237,
    16245,
    16255,
    16267,
    16275,
    16279,
    16287,
    16297,
    16309,
    16329,
    16333,
    16341,
    16353,
    16359,
    16365,
    16381,
    16387,
    16389,
    16393,
    16395,
    16413,
    16417,
    16429,
    16431,
    16447,
    16449,
    16467,
    16473,
    16479,
    16491,
    16507,
    16521,
    16539,
    16557,
    16573,
    16591,
    16611,
    16615,
    16617,
    16621,
    16635,
    16639,
    16657,
    16665,
    16677,
    16701,
    16707,
    16725,
    16747,
    16765,
    16771,
    16773,
    16791,
    16795,
    16825,
    16827,
    16845,
    16863,
    16867,
    16893,
    16915,
    16917,
    16921,
    16933,
    16939,
    16947,
    16953,
    16957,
    16959,
    16969,
    16971,
    16981,
    16995,
    17001,
    17011,
    17017,
    17019,
    17035,
    17047,
    17053,
    17061,
    17083,
    17085,
    17103,
    17115,
    17119,
    17125,
    17127,
    17151,
    17157,
    17173,
    17181,
    17209,
    17211,
    17215,
    17221,
    17223,
    17229,
    17251,
    17253,
    17283,
    17287,
    17305,
    17313,
    17329,
    17335,
    17341,
    17355,
    17359,
    17367,
    17389,
    17391,
    17401,
    17409,
    17431,
    17433,
    17455,
    17463,
    17467,
    17473,
    17485,
    17497,
    17517,
    17527,
    17535,
    17545,
    17547,
    17563,
    17565,
    17581,
    17589,
    17619,
    17625,
    17671,
    17677,
    17689,
    17695,
    17703,
    17713,
    17725,
    17733,
    17737,
    17749,
    17767,
    17769,
    17775,
    17781,
    17787,
    17797,
    17811,
    17829,
    17851,
    17875,
    17883,
    17893,
    17913,
    17925,
    17935,
    17943,
    17947,
    17965,
    17977,
    17991,
    17997,
    18001,
    18007,
    18019,
    18025,
    18043,
    18049,
    18055,
    18067,
    18085,
    18087,
    18123,
    18127,
    18145,
    18147,
    18151,
    18153,
    18169,
    18175,
    18181,
    18187,
    18189,
    18195,
    18207,
    18211,
    18237,
    18253,
    18261,
    18279,
    18283,
    18285,
    18295,
    18303,
    18315,
    18333,
    18375,
    18381,
    18397,
    18399,
    18403,
    18409,
    18441,
    18445,
    18451,
    18459,
    18465,
    18469,
    18475,
    18493,
    18495,
    18501,
    18513,
    18523,
    18535,
    18543,
    18589,
    18591,
    18597,
    18615,
    18619,
    18621,
    18633,
    18639,
    18655,
    18661,
    18681,
    18693,
    18715,
    18717,
    18723,
    18745,
    18747,
    18757,
    18759,
    18765,
    18775,
    18777,
    18783,
    18787,
    18817,
    18819,
    18825,
    18837,
    18849,
    18853,
    18871,
    18873,
    18879,
    18915,
    18937,
    18943,
    18951,
    18967,
    18969,
    18975,
    18979,
    18987,
    19009,
    19015,
    19017,
    19033,
    19051,
    19081,
    19113,
    19119,
    19125,
    19131,
    19153,
    19155,
    19159,
    19161,
    19173,
    19195,
    19197,
    19207,
    19225,
    19237,
    19261,
    19263,
    19269,
    19285,
    19309,
    19323,
    19327,
    19329,
    19333,
    19341,
    19347,
    19351,
    19357,
    19363,
    19365,
    19371,
    19389,
    19395,
    19405,
    19411,
    19417,
    19435,
    19455,
    19467,
    19477,
    19479,
    19503,
    19521,
    19533,
    19543,
    19551,
    19579,
    19581,
    19603,
    19609,
    19615,
    19627,
    19629,
    19657,
    19659,
    19687,
    19693,
    19705,
    19707,
    19711,
    19719,
    19723,
    19725,
    19731,
    19735,
    19755,
    19767,
    19771,
    19773,
    19783,
    19791,
    19807,
    19825,
    19851,
    19861,
    19869,
    19875,
    19893,
    19917,
    19921,
    19929,
    19939,
    19963,
    19981,
    19993,
    20005,
    20013,
    20017,
    20043,
    20067,
    20071,
    20077,
    20085,
    20089,
    20101,
    20103,
    20121,
    20133,
    20149,
    20151,
    20169,
    20181,
    20185,
    20197,
    20203,
    20215,
    20227,
    20253,
    20257,
    20271,
    20295,
    20307,
    20319,
    20341,
    20349,
    20353,
    20355,
    20359,
    20371,
    20379,
    20385,
    20397,
    20403,
    20425,
    20445,
    20449,
    20455,
    20461,
    20475,
    20485,
    20487,
    20509,
    20511,
    20539,
    20551,
    20563,
    20581,
    20583,
    20587,
    20605,
    20611,
    20613,
    20649,
    20665,
    20679,
    20697,
    20713,
    20731,
    20733,
    20739,
    20757,
    20763,
    20769,
    20773,
    20793,
    20797,
    20805,
    20811,
    20821,
    20823,
    20833,
    20835,
    20839,
    20845,
    20859,
    20875,
    20887,
    20889,
    20899,
    20905,
    20923,
    20937,
    20941,
    20953,
    20959,
    20965,
    20991,
    21013,
    21015,
    21021,
    21027,
    21043,
    21049,
    21051,
    21055,
    21073,
    21075,
    21111,
    21115,
    21129,
    21139,
    21147,
    21153,
    21169,
    21175,
    21177,
    21189,
    21193,
    21199,
    21205,
    21211,
    21223,
    21231,
    21253,
    21255,
    21307,
    21309,
    21315,
    21327,
    21331,
    21337,
    21345,
    21373,
    21381,
    21405,
    21409,
    21411,
    21421,
    21433,
    21445,
    21451,
    21453,
    21469,
    21471,
    21475,
    21499,
    21505,
    21529,
    21531,
    21537,
    21549,
    21567,
    21571,
    21591,
    21597,
    21609,
    21613,
    21615,
    21621,
    21655,
    21663,
    21687,
    21693,
    21703,
    21709,
    21717,
    21721,
    21735,
    21739,
    21751,
    21757,
    21759,
    21771,
    21787,
    21819,
    21841,
    21847,
    21867,
    21885,
    21891,
    21897,
    21913,
    21915,
    21925,
    21927,
    21931,
    21933,
    21957,
    21967,
    21987,
    21993,
    22009,
    22017,
    22035,
    22039,
    22075,
    22087,
    22093,
    22095,
    22099,
    22113,
    22119,
    22125,
    22147,
    22155,
    22165,
    22167,
    22177,
    22185,
    22197,
    22225,
    22227,
    22231,
    22269,
    22281,
    22305,
    22327,
    22333,
    22339,
    22369,
    22371,
    22377,
    22381,
    22399,
    22401,
    22411,
    22417,
    22431,
    22437,
    22461,
    22471,
    22473,
    22479,
    22503,
    22507,
    22521,
    22525,
    22527,
    22533,
    22555,
    22569,
    22585,
    22587,
    22591,
    22597,
    22603,
    22617,
    22627,
    22629,
    22651,
    22683,
    22687,
    22689,
    22701,
    22711,
    22743,
    22779,
    22789,
    22791,
    22795,
    22807,
    22827,
    22839,
    22843,
    22851,
    22855,
    22869,
    22879,
    22881,
    22885,
    22893,
    22911,
    22921,
    22941,
    22947,
    22953,
    22957,
    22965,
    22969,
    22975,
    22981,
    22987,
    22999,
    23007,
    23031,
    23037,
    23041,
    23061,
    23067,
    23083,
    23089,
    23095,
    23101,
    23109,
    23137,
    23145,
    23163,
    23169,
    23173,
    23191,
    23193,
    23199,
    23205,
    23269,
    23271,
    23293,
    23295,
    23311,
    23323,
    23341,
    23343,
    23353,
    23355,
    23361,
    23365,
    23373,
    23377,
    23397,
    23419,
    23421,
    23427,
    23445,
    23449,
    23451,
    23457,
    23469,
    23479,
    23499,
    23515,
    23523,
    23529,
    23533,
    23551,
    23563,
    23565,
    23569,
    23571,
    23577,
    23607,
    23613,
    23649,
    23671,
    23677,
    23689,
    23701,
    23709,
    23721,
    23767,
    23775,
    23781,
    23799,
    23805,
    23815,
    23829,
    23835,
    23851,
    23857,
    23881,
    23889,
    23893,
    23913,
    23919,
    23925,
    23929,
    23943,
    23953,
    23955,
    23961,
    23965,
    23971,
    23973,
    23991,
    24013,
    24015,
    24025,
    24033,
    24037,
    24069,
    24073,
    24117,
    24121,
    24129,
    24133,
    24145,
    24151,
    24181,
    24183,
    24213,
    24217,
    24237,
    24247,
    24255,
    24261,
    24277,
    24285,
    24289,
    24301,
    24309,
    24321,
    24327,
    24331,
    24333,
    24343,
    24363,
    24381,
    24387,
    24397,
    24403,
    24405,
    24423,
    24429,
    24447,
    24451,
    24481,
    24499,
    24523,
    24531,
    24571,
    24573,
    24585,
    24591,
    24603,
    24619,
    24633,
    24637,
    24639,
    24643,
    24645,
    24649,
    24663,
    24669,
    24709,
    24711,
    24727,
    24729,
    24733,
    24739,
    24741,
    24759,
    24763,
    24771,
    24783,
    24789,
    24805,
    24811,
    24829,
    24831,
    24843,
    24855,
    24865,
    24873,
    24877,
    24895,
    24907,
    24909,
    24933,
    24951,
    24957,
    24963,
    24985,
    24991,
    25015,
    25017,
    25021,
    25033,
    25057,
    25063,
    25095,
    25099,
    25107,
    25117,
    25119,
    25129,
    25147,
    25153,
    25159,
    25167,
    25171,
    25185,
    25189,
    25201,
    25213,
    25215,
    25225,
    25237,
    25255,
    25263,
    25285,
    25287,
    25293,
    25309,
    25317,
    25335,
    25341,
    25347,
    25377,
    25389,
    25413,
    25425,
    25431,
    25441,
    25455,
    25461,
    25477,
    25483,
    25489,
    25497,
    25503,
    25525,
    25549,
    25561,
    25567,
    25569,
    25581,
    25591,
    25593,
    25611,
    25621,
    25623,
    25645,
    25647,
    25657,
    25671,
    25677,
    25687,
    25737,
    25753,
    25759,
    25771,
    25773,
    25803,
    25815,
    25819,
    25821,
    25833,
    25837,
    25845,
    25855,
    25861,
    25875,
    25893,
    25909,
    25917,
    25923,
    25929,
    25939,
    25959,
    25963,
    25971,
    25977,
    25987,
    26005,
    26007,
    26011,
    26025,
    26035,
    26041,
    26071,
    26085,
    26103,
    26107,
    26115,
    26119,
    26149,
    26155,
    26167,
    26169,
    26179,
    26209,
    26215,
    26217,
    26221,
    26229,
    26251,
    26263,
    26281,
    26293,
    26295,
    26301,
    26313,
    26319,
    26343,
    26347,
    26359,
    26365,
    26385,
    26397,
    26409,
    26413,
    26431,
    26445,
    26467,
    26505,
    26523,
    26529,
    26533,
    26547,
    26553,
    26565,
    26595,
    26599,
    26617,
    26629,
    26641,
    26649,
    26655,
    26659,
    26665,
    26683,
    26695,
    26697,
    26703,
    26719,
    26721,
    26727,
    26733,
    26749,
    26755,
    26757,
    26781,
    26797,
    26805,
    26841,
    26845,
    26847,
    26881,
    26883,
    26893,
    26905,
    26907,
    26913,
    26923,
    26925,
    26935,
    26943,
    26997,
    27001,
    27007,
    27009,
    27013,
    27027,
    27031,
    27033,
    27037,
    27039,
    27061,
    27063,
    27075,
    27079,
    27091,
    27093,
    27097,
    27105,
    27141,
    27157,
    27189,
    27195,
    27199,
    27201,
    27205,
    27207,
    27217,
    27237,
    27265,
    27271,
    27283,
    27301,
    27309,
    27315,
    27321,
    27325,
    27331,
    27333,
    27349,
    27357,
    27363,
    27387,
    27393,
    27409,
    27415,
    27417,
    27427,
    27435,
    27453,
    27457,
    27469,
    27475,
    27477,
    27483,
    27489,
    27493,
    27501,
    27511,
    27531,
    27541,
    27561,
    27585,
    27595,
    27597,
    27603,
    27639,
    27663,
    27667,
    27691,
    27693,
    27705,
    27711,
    27741,
    27751,
    27757,
    27765,
    27783,
    27793,
    27805,
    27807,
    27813,
    27829,
    27831,
    27847,
    27855,
    27859,
    27871,
    27879,
    27913,
    27915,
    27951,
    27961,
    27963,
    27975,
    28021,
    28023,
    28027,
    28039,
    28069,
    28071,
    28083,
    28087,
    28089,
    28101,
    28105,
    28119,
    28123,
    28129,
    28131,
    28141,
    28161,
    28167,
    28191,
    28195,
    28203,
    28233,
    28239,
    28245,
    28293,
    28311,
    28321,
    28329,
    28339,
    28351,
    28359,
    28365,
    28375,
    28393,
    28405,
    28417,
    28429,
    28435,
    28437,
    28459,
    28467,
    28483,
    28509,
    28513,
    28525,
    28563,
    28569,
    28581,
    28593,
    28605,
    28633,
    28639,
    28677,
    28689,
    28701,
    28707,
    28735,
    28759,
    28765,
    28771,
    28791,
    28797,
    28801,
    28803,
    28815,
    28825,
    28827,
    28837,
    28843,
    28855,
    28857,
    28867,
    28869,
    28887,
    28891,
    28905,
    28921,
    28923,
    28933,
    28951,
    28963,
    28969,
    28987,
    28989,
    28993,
    28995,
    29005,
    29025,
    29031,
    29035,
    29049,
    29055,
    29065,
    29089,
    29091,
    29095,
    29113,
    29121,
    29127,
    29137,
    29143,
    29149,
    29157,
    29175,
    29185,
    29193,
    29203,
    29205,
    29239,
    29253,
    29281,
    29283,
    29287,
    29295,
    29311,
    29317,
    29319,
    29329,
    29341,
    29349,
    29371,
    29391,
    29413,
    29437,
    29451,
    29457,
    29467,
    29473,
    29485,
    29487,
    29493,
    29497,
    29515,
    29517,
    29521,
    29533,
    29535,
    29563,
    29577,
    29589,
    29595,
    29599,
    29611,
    29613,
    29623,
    29625,
    29653,
    29659,
    29661,
    29665,
    29677,
    29689,
    29697,
    29709,
    29715,
    29721,
    29751,
    29757,
    29779,
    29781,
    29787,
    29791,
    29805,
    29815,
    29829,
    29845,
    29847,
    29851,
    29865,
    29877,
    29893,
    29905,
    29913,
    29925,
    29949,
    29959,
    29971,
    29973,
    29989,
    29995,
    30013,
    30021,
    30061,
    30067,
    30073,
    30075,
    30087,
    30103,
    30115,
    30121,
    30159,
    30163,
    30181,
    30207,
    30225,
    30229,
    30231,
    30241,
    30243,
    30253,
    30261,
    30265,
    30273,
    30289,
    30291,
    30303,
    30313,
    30327,
    30337,
    30367,
    30369,
    30373,
    30387,
    30397,
    30409,
    30411,
    30429,
    30439,
    30465,
    30471,
    30475,
    30477,
    30495,
    30499,
    30505,
    30523,
    30529,
    30537,
    30541,
    30543,
    30547,
    30559,
    30565,
    30567,
    30589,
    30601,
    30643,
    30651,
    30681,
    30687,
    30727,
    30747,
    30753,
    30765,
    30775,
    30777,
    30789,
    30793,
    30807,
    30817,
    30837,
    30849,
    30861,
    30871,
    30873,
    30877,
    30885,
    30901,
    30915,
    30919,
    30943,
    30945,
    30949,
    30969,
    30997,
    30999,
    31003,
    31021,
    31029,
    31033,
    31039,
    31051,
    31069,
    31071,
    31081,
    31093,
    31095,
    31107,
    31135,
    31137,
    31143,
    31147,
    31189,
    31191,
    31207,
    31221,
    31231,
    31237,
    31239,
    31249,
    31251,
    31255,
    31261,
    31263,
    31293,
    31303,
    31311,
    31315,
    31335,
    31341,
    31363,
    31381,
    31383,
    31387,
    31389,
    31395,
    31405,
    31411,
    31425,
    31429,
  ];
  let partitionNumbers = [
    1,
    2,
    3,
    5,
    7,
    11,
    15,
    22,
    30,
    42,
    56,
    77,
    101,
    135,
    176,
    231,
    297,
    385,
    490,
    627,
    792,
    1002,
    1255,
    1575,
    1958,
    2436,
    3010,
    3718,
    4565,
    5604,
    6842,
    8349,
    10143,
    12310,
    14883,
    17977,
    21637,
    26015,
    31185,
    37338,
    44583,
    53174,
    63261,
    75175,
    89134,
    105558,
    124754,
    147273,
    173525,
    204226,
    239943,
    281589,
    329931,
    386155,
    451276,
    526823,
    614154,
    715220,
    831820,
    966467,
    1121505,
    1300156,
    1505499,
    1741630,
    2012558,
    2323520,
    2679689,
    3087735,
    3554345,
    4087968,
    4697205,
    5392783,
    6185689,
    7089500,
    8118264,
    9289091,
    10619863,
    12132164,
    13848650,
    15796476,
    18004327,
    20506255,
    23338469,
    26543660,
    30167357,
    34262962,
    38887673,
    44108109,
    49995925,
    56634173,
    64112359,
    72533807,
    82010177,
    92669720,
    104651419,
    118114304,
    133230930,
    150198136,
    169229875,
    190569292,
    214481126,
    241265379,
    271248950,
    304801365,
    342325709,
    384276336,
    431149389,
    483502844,
    541946240,
    607163746,
    679903203,
    761002156,
    851376628,
    952050665,
    1064144451,
    1188908248,
    1327710076,
    1482074143,
    1653668665,
    1844349560,
    2056148051,
    2291320912,
    2552338241,
    2841940500,
    3163127352,
    3519222692,
    3913864295,
    4351078600,
    4835271870,
    5371315400,
    5964539504,
    6620830889,
    7346629512,
    8149040695,
    9035836076,
    10015581680,
    11097645016,
    12292341831,
    13610949895,
    15065878135,
    16670689208,
    18440293320,
    20390982757,
    22540654445,
    24908858009,
    27517052599,
    30388671978,
    33549419497,
    37027355200,
    40853235313,
    45060624582,
    49686288421,
    54770336324,
    60356673280,
    66493182097,
    73232243759,
    80630964769,
    88751778802,
    97662728555,
    107438159466,
    118159068427,
    129913904637,
    142798995930,
    156919475295,
    172389800255,
    189334822579,
    207890420102,
    228204732751,
    250438925115,
    274768617130,
    301384802048,
    330495499613,
    362326859895,
    397125074750,
    435157697830,
    476715857290,
    522115831195,
    571701605655,
    625846753120,
    684957390936,
    749474411781,
    819876908323,
    896684817527,
    980462880430,
    1071823774337,
    1171432692373,
    1280011042268,
    1398341745571,
    1527273599625,
    1667727404093,
    1820701100652,
    1987276856363,
    2168627105469,
    2366022741845,
    2580840212973,
    2814570987591,
    3068829878530,
    3345365983698,
    3646072432125,
    3972999029388,
    4328363658647,
    4714566886083,
    5134205287973,
    5590088317495,
    6085253859260,
    6622987708040,
    7206841706490,
    7840656226137,
    8528581302375,
    9275102575355,
    10085065885767,
    10963707205259,
    11916681236278,
    12950095925895,
    14070545699287,
    15285151248481,
    16601598107914,
    18028182516671,
    19573856161145,
    21248279009367,
    23061871173849,
    25025873760111,
    27152408925615,
    29454549941750,
    31946390696157,
    34643126322519,
    37561133582570,
    40718063627362,
    44132934884255,
    47826239745920,
    51820051838712,
    56138148670947,
    60806135438329,
    65851585970275,
    71304185514919,
    77195892663512,
    83561103925871,
    90436839668817,
    97862933703585,
    105882246722733,
    114540884553038,
    123888443077259,
    133978259344888,
    144867692496445,
    156618412527946,
    169296722391554,
    182973889854026,
    197726516681672,
    213636919820625,
    230793554364681,
    249291451168559,
    269232701252579,
    290726957916112,
    313891991306665,
    338854264248680,
    365749566870782,
    394723676655357,
    425933084409356,
    459545750448675,
    495741934760846,
    534715062908609,
    576672674947168,
    621837416509615,
    670448123060170,
    722760953690372,
    779050629562167,
    839611730366814,
    904760108316360,
    974834369944625,
    1050197489931117,
    1131238503938606,
    1218374349844333,
    1312051800816215,
    1412749565173450,
    1520980492851175,
    1637293969337171,
    1762278433057269,
    1896564103591584,
    2040825852575075,
    2195786311682516,
    2362219145337711,
    2540952590045698,
    2732873183547535,
    2938929793929555,
    3160137867148997,
    3397584011986773,
    3652430836071053,
    3925922161489422,
    4219388528587095,
    4534253126900886,
    4872038056472084,
    5234371069753672,
    5622992691950605,
    6039763882095515,
    6486674127079088,
    6965850144195831,
    7479565078510584,
    8030248384943040,
    8620496275465025,
  ];
  {
    fibonacciTakeWhile: (fn) -> loop(result = [], a = 0, b = 1, i = 0) -> if fn(
      a,
      i
    ) then
      recur(push(result, a), b, a + b, i + 1)
    else
      result
    end,
    tribonacciTakeWhile: (fn) -> loop(result = [], a = 0, b = 1, c = 1, i = 0) -> if fn(
      a,
      i
    ) then
      recur(push(result, a), b, c, a + b + c, i + 1)
    else
      result
    end,
    lucasTakeWhile: (fn) -> loop(result = [], a = 2, b = 1, i = 0) -> if fn(
      a,
      i
    ) then
      recur(push(result, a), b, a + b, i + 1)
    else
      result
    end,
    pellTakeWhile: (fn) -> loop(result = [], a = 1, b = 2, i = 0) -> if fn(a, i) then
      recur(push(result, a), b, 2 * b + a, i + 1)
    else
      result
    end,
    padovanTakeWhile: (fn) -> loop(result = [], a = 1, b = 1, c = 1, i = 0) -> if fn(
      a,
      i
    ) then
      recur(push(result, a), b, c, a + b, i + 1)
    else
      result
    end,
    factorialTakeWhile: (fn) -> loop(result = [], fact = 1, i = 0) -> if fn(
      fact,
      i
    ) then
      recur(push(result, fact), fact * (i + 1), i + 1)
    else
      result
    end,
    primeTakeWhile: (fn) -> loop(result = [], n = 2) -> if isPrime(n) then
      if fn(n, count(result)) then recur(push(result, n), n + 1) else result end
    else
      recur(result, n + 1)
    end,
    compositeTakeWhile: (fn) -> loop(result = [], n = 4) -> if isComposite(n) then
      if fn(n, count(result)) then recur(push(result, n), n + 1) else result end
    else
      recur(result, n + 1)
    end,
    abundantTakeWhile: (fn) -> loop(result = [], n = 12) -> if isAbundant(n) then
      if fn(n, count(result)) then recur(push(result, n), n + 1) else result end
    else
      recur(result, n + 1)
    end,
    deficientTakeWhile: (fn) -> loop(result = [], n = 1) -> if isDeficient(n) then
      if fn(n, count(result)) then recur(push(result, n), n + 1) else result end
    else
      recur(result, n + 1)
    end,
    perfectSquareTakeWhile: (fn) -> loop(result = [], i = 1) -> do
      let val = i * i;
      if fn(val, i - 1) then recur(push(result, val), i + 1) else result end;
    end,
    perfectCubeTakeWhile: (fn) -> loop(result = [], i = 1) -> do
      let val = i * i * i;
      if fn(val, i - 1) then recur(push(result, val), i + 1) else result end;
    end,
    happyTakeWhile: (fn) -> loop(result = [], n = 1) -> if isHappy(n) then
      if fn(n, count(result)) then recur(push(result, n), n + 1) else result end
    else
      recur(result, n + 1)
    end,
    arithmeticTakeWhile: (start, step, fn) -> loop(result = [], i = 0) -> do
      let val = start + i * step;
      if fn(val, i) then recur(push(result, val), i + 1) else result end;
    end,
    geometricTakeWhile: (start, ratio, fn) -> loop(result = [], i = 0) -> do
      let val = start * ratio ^ i;
      if fn(val, i) then recur(push(result, val), i + 1) else result end;
    end,
    polygonalTakeWhile: (sides, fn) -> loop(result = [], n = 1) -> do
      let val = (sides - 2) * n * (n - 1) / 2 + n;
      if fn(val, n - 1) then recur(push(result, val), n + 1) else result end;
    end,
    lookAndSayTakeWhile: (fn) -> do
      let nextTerm = (s) -> loop(result = "", i = 0) -> if i >= count(s) then
        result
      else
        do
          let ch = nth(s, i);
          let cnt =
            loop(c = 1, j = i + 1) -> if j < count(s) && nth(s, j) == ch then
              recur(c + 1, j + 1)
            else
              c
            end;
          recur(++(result, str(cnt), ch), i + cnt);
        end
      end;
      loop(result = [], term = "1", idx = 0) -> if fn(term, idx) then
        recur(push(result, term), nextTerm(term), idx + 1)
      else
        result
      end;
    end,
    bellTakeWhile: (fn) -> loop(result = [], i = 0) -> if i >=
      count(bellNumbers) then
      result
    else if fn(nth(bellNumbers, i), i) then
      recur(push(result, nth(bellNumbers, i)), i + 1)
    else
      result
    end,
    catalanTakeWhile: (fn) -> loop(result = [], i = 0) -> if i >=
      count(catalanNumbers) then
      result
    else if fn(nth(catalanNumbers, i), i) then
      recur(push(result, nth(catalanNumbers, i)), i + 1)
    else
      result
    end,
    mersenneTakeWhile: (fn) -> loop(result = [], i = 0) -> if i >=
      count(mersenneNumbers) then
      result
    else if fn(nth(mersenneNumbers, i), i) then
      recur(push(result, nth(mersenneNumbers, i)), i + 1)
    else
      result
    end,
    partitionTakeWhile: (fn) -> loop(result = [], i = 0) -> if i >=
      count(partitionNumbers) then
      result
    else if fn(nth(partitionNumbers, i), i) then
      recur(push(result, nth(partitionNumbers, i)), i + 1)
    else
      result
    end,
    perfectTakeWhile: (fn) -> loop(result = [], i = 0) -> if i >=
      count(perfectNumbers) then
      result
    else if fn(nth(perfectNumbers, i), i) then
      recur(push(result, nth(perfectNumbers, i)), i + 1)
    else
      result
    end,
    sylvesterTakeWhile: (fn) -> loop(result = [], i = 0) -> if i >=
      count(sylvesterNumbers) then
      result
    else if fn(nth(sylvesterNumbers, i), i) then
      recur(push(result, nth(sylvesterNumbers, i)), i + 1)
    else
      result
    end,
    bernoulliTakeWhile: (fn) -> loop(bArr = [1], n = 1) -> do
      let bn =
        if n > 1 && n % 2 == 1 then
          0
        else
          do
            let s =
              loop(k = 0, acc = 0) -> if k >= n then
                acc
              else
                recur(k + 1, acc + binom(n + 1, k) * nth(bArr, k))
              end;
            (-s) / (n + 1);
          end
        end;
      if fn(bn, n) then recur(push(bArr, bn), n + 1) else bArr end;
    end,
    golombTakeWhile: (fn) -> if not(fn(1, 0)) then
      []
    else
      do
        loop(gArr = [1], n = 2) -> do
          let gn1 = nth(gArr, n - 2);
          let ggn1 = nth(gArr, gn1 - 1);
          let gval = 1 + nth(gArr, n - 1 - ggn1);
          if fn(gval, n - 1) then recur(push(gArr, gval), n + 1) else gArr end;
        end;
      end
    end,
    luckyTakeWhile: (fn) -> loop(result = [], i = 0) -> if i >=
      count(luckyNumbers) then
      result
    else if fn(nth(luckyNumbers, i), i) then
      recur(push(result, nth(luckyNumbers, i)), i + 1)
    else
      result
    end,
    perfectPowerTakeWhile: (fn) -> loop(result = [], n = 1) -> if isPerfectPower(
      n
    ) then
      if fn(n, count(result)) then recur(push(result, n), n + 1) else result end
    else
      recur(result, n + 1)
    end,
    recamanTakeWhile: (fn) -> do
      let inArr = (arr, val) -> loop(i = 0) -> if i >= count(arr) then
        false
      else if nth(arr, i) == val then
        true
      else
        recur(i + 1)
      end;
      if not(fn(0, 0)) then
        []
      else
        do
          loop(result = [0], n = 1) -> do
            let prev = nth(result, n - 1);
            let backward = prev - n;
            let nxt =
              if backward > 0 && not(inArr(result, backward)) then
                backward
              else
                prev + n
              end;
            if fn(nxt, n) then recur(push(result, nxt), n + 1) else result end;
          end;
        end
      end;
    end,
    thueMorseTakeWhile: (fn) -> loop(result = [], i = 0) -> do
      let val = countBits(i) % 2;
      if fn(val, i) then recur(push(result, val), i + 1) else result end;
    end,
  };
end;
// Helper predicates
// =========================================================================
// FINITE SEQUENCES — generate inline
// =========================================================================
// =========================================================================
// PREDICATE SEQUENCES — use inline predicates
// =========================================================================
// =========================================================================
// PARAMETERIZED SEQUENCES
// =========================================================================
// =========================================================================
// FINITE SEQUENCES — iterate precomputed arrays
// =========================================================================
// =========================================================================
// DYNAMIC SEQUENCES — generate on-the-fly
// =========================================================================
// bArr accumulates all Bernoulli numbers computed so far; B(0)=1 is always included
// gArr is 0-indexed: gArr[i] = g(i+1). g(1)=1, g(n)=1+g(n-g(g(n-1)))
